import { initializeApp } from 'firebase/app';
import { getDatabase ,ref} from "firebase/database";

const config = {
    apiKey: "AIzaSyDUTQNMPlU9xRCe2f7M3emyrGQcwe1Lyug",
    authDomain: "moveitpro-157901.firebaseapp.com",
    databaseURL: "https://moveitpro-157901.firebaseio.com",
    projectId: "moveitpro-157901",
    storageBucket: "moveitpro-157901.appspot.com",
    messagingSenderId: "1012392955102"
};
const app = initializeApp(config);
const database = getDatabase(app);

export default database;